import AddLocationIcon from "@mui/icons-material/AddLocation";
import BeenhereIcon from "@mui/icons-material/Beenhere";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EditLocationIcon from "@mui/icons-material/EditLocation";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import PersonPinCircleIcon from "@mui/icons-material/PersonPinCircle";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import ReportIcon from "@mui/icons-material/Report";
import FlagIcon from "@mui/icons-material/Flag";
import AccessibilityIcon from "@mui/icons-material/Accessibility";
import StarsIcon from "@mui/icons-material/Stars";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import BuildIcon from "@mui/icons-material/Build";
import ErrorIcon from "@mui/icons-material/Error";
import NearMeIcon from "@mui/icons-material/NearMe";
import RoomIcon from "@mui/icons-material/Room";
import WhereToVoteIcon from "@mui/icons-material/WhereToVote";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { SettingDropSelector } from "./SpreadsheetSettingSharedComponents";

import beenHere from "../../assets/mapIcons/beenHere.png";
import addLocation from "../../assets/mapIcons/addLocation.png";
import checkCircle from "../../assets/mapIcons/checkCircle.png";
import editLocation from "../../assets/mapIcons/editLocation.png";
import localOffer from "../../assets/mapIcons/localOffer.png";
import personPinCircle from "../../assets/mapIcons/personPinCircle.png";
import addCircle from "../../assets/mapIcons/addCircle.png";
import report from "../../assets/mapIcons/report.png";
import flag from "../../assets/mapIcons/flag.png";
import accessibility from "../../assets/mapIcons/accessibility.png";
import stars from "../../assets/mapIcons/stars.png";
import priorityHigh from "../../assets/mapIcons/priorityHigh.png";
import build from "../../assets/mapIcons/build.png";
import error from "../../assets/mapIcons/error.png";
import nearMe from "../../assets/mapIcons/nearMe.png";
import room from "../../assets/mapIcons/room.png";
import whereToVote from "../../assets/mapIcons/whereToVote.png";
import camera from "../../assets/mapIcons/camera.png";
import aed from "../../assets/mapIcons/heart-attack.png";
import { faHeartbeat } from "@fortawesome/free-solid-svg-icons";

const iconsObject = {
  beenHere: {
    image: beenHere,
    icon: (
      <>
        <BeenhereIcon /> Check Badge
      </>
    ),
  },
  addLocation: {
    image: addLocation,
    icon: (
      <>
        <AddLocationIcon /> Plus Pin
      </>
    ),
  },
  checkCircle: {
    image: checkCircle,
    icon: (
      <>
        <CheckCircleIcon /> Check Circle
      </>
    ),
  },
  editLocation: {
    image: editLocation,
    icon: (
      <>
        <EditLocationIcon /> Edit Pin
      </>
    ),
  },
  localOffer: {
    image: localOffer,
    icon: (
      <>
        <LocalOfferIcon /> Tag Marker
      </>
    ),
  },
  personPinCircle: {
    image: personPinCircle,
    icon: (
      <>
        <PersonPinCircleIcon /> Person Pin
      </>
    ),
  },
  addCircle: {
    image: addCircle,
    icon: (
      <>
        <AddCircleIcon /> Plus Circle
      </>
    ),
  },
  report: {
    image: report,
    icon: (
      <>
        <ReportIcon /> Exclamation Octogon
      </>
    ),
  },
  flag: {
    image: flag,
    icon: (
      <>
        <FlagIcon /> Flag Marker
      </>
    ),
  },
  accessibility: {
    image: accessibility,
    icon: (
      <>
        <AccessibilityIcon /> Person Marker
      </>
    ),
  },
  stars: {
    image: stars,
    icon: (
      <>
        <StarsIcon /> Star Circle
      </>
    ),
  },
  priorityHigh: {
    image: priorityHigh,
    icon: (
      <>
        <PriorityHighIcon /> Exclamation Marker
      </>
    ),
  },
  build: {
    image: build,
    icon: (
      <>
        <BuildIcon /> Wrench Marker
      </>
    ),
  },
  error: {
    image: error,
    icon: (
      <>
        <ErrorIcon /> Exclamation Circle
      </>
    ),
  },
  nearMe: {
    image: nearMe,
    icon: (
      <>
        <NearMeIcon /> Arrow Marker
      </>
    ),
  },
  room: {
    image: room,
    icon: (
      <>
        <RoomIcon /> Circle Pin
      </>
    ),
  },
  whereToVote: {
    image: whereToVote,
    icon: (
      <>
        <WhereToVoteIcon /> Check Pin
      </>
    ),
  },
  camera: {
    image: camera,
    icon: (
      <>
        <PhotoCameraIcon /> Camera
      </>
    ),
  },
  aed: {
    image: aed,
    icon: (
      <>
        <FontAwesomeIcon icon={faHeartbeat} /> AED
      </>
    ),
  },
};

export const iconArray = Object.keys(iconsObject).map((key) => {
  return {
    value: key,
    label: iconsObject[key].icon,
  };
});

export const addIconsToMap = (map) => {
  for (let marker in iconsObject) {
    const { image } = iconsObject[marker];
    map.loadImage(image, (error, image) => {
      if (error) throw error;
      if (!map.hasImage(marker))
        map.addImage(marker, image, {
          sdf: true,
          pixelRatio: 2,
        });
    });
  }
};

export default function SharedIconSelector(props) {
  const handleSelection = (icon) => {
    props.handleSelection(icon);
  };

  return (
    <SettingDropSelector
      label="Select Icon"
      value={props.value}
      handleSelection={handleSelection}
      labelIcon={<AddLocationIcon />}
      active={props.active}
      fullWidth={false}
      optionsArray={iconArray}
      defaultOption={{
        label: "No Icon",
        value: "",
      }}
    />
  );
}
